(ns common.schema.entities.ic-decision.permissions
  (:require
   [common.schema.entities.permission-checks :as permission-checks]))

(defn read-permissions?
  [ctx]
  (permission-checks/decision-read-check-fn ctx))

(defn disable-permissions?
  [ctx]
  (permission-checks/decision-disable-permissions-check-fn ctx))
